import { createStore, applyMiddleware, compose } from 'redux';
//import { composeWithDevTools } from '@redux-devtools/extension';
import thunk from 'redux-thunk';

import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { rootReducer as reducer } from 'redux/reducers';

const middleware = [thunk];

const persistConfig = {
    key: 'root',
    storage
    //blacklist: ['signinup']
};

const persistedReducer = persistReducer(persistConfig, reducer);

//export const store = createStore(persistedReducer, composeWithDevTools(compose(applyMiddleware(...middleware))));
export const store = createStore(persistedReducer, compose(applyMiddleware(...middleware)));

export const persistor = persistStore(store);